export const ABSENCE_STATISTICAL_CATEGORIES = ['vacation', 'sickleave', 'leave', 'personal'];

export const CATEGORY_LABELS = {
  vacation: 'Ferie',
  sickleave: 'Sygefravær',
  leave: 'Orlov',
  personal: 'Personlig',
};

export const APPROVAL_LABELS = {
  approval_wish: 'wish',
  approval_wish_approved: 'approved',
  approval_wish_rejected: 'rejected',
};

export const APPROVAL_COLORS = {
  approval_wish: 'warning',
  approval_wish_approved: 'success',
  approval_wish_rejected: 'error',
};

export const APPROVAL_CHIP = {
  approval_wish: { label: 'Afventer godkendelse', color: 'warning' },
  approval_wish_approved: { label: 'Godkendt', color: 'success' },
  approval_wish_rejected: { label: 'Afvist', color: 'error' },
};

// Standard Danish full-time hours per work day
export const HOURS_PER_DAY = 7.4;

// Consecutive sick days before case is classified as long-term
export const LONG_TERM_SICK_THRESHOLD = 30;

// Consecutive sick days before warning about missing doctor note
export const DOCTOR_NOTE_THRESHOLD = 3;
